module.exports = __webpack_public_path__ + "img/ButtonArrow.ca0edf10.svg";